import { render, staticRenderFns } from "./ShapeBrandLineDotted.vue?vue&type=template&id=61fa23b1"
import script from "./ShapeBrandLineDotted.vue?vue&type=script&lang=js"
export * from "./ShapeBrandLineDotted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports